import React from 'react';

import { useId } from 'ui/utils';

type Props = {
  name?: string;
  id?: string;
  label?: string;
  helpText?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  value: boolean;
  onChange?: (value: boolean) => void;
  error?: string;
  stopOnClickPropagation?: boolean;
};

function Checkbox({
  name,
  id,
  label,
  helpText,
  required,
  disabled,
  value,
  onChange,
  error,
  stopOnClickPropagation,
}: Props) {
  const internalId = useId();

  if (!name) {
    name = `checkbox-${internalId}`;
  }

  if (!id) {
    id = `${name}__id`;
  }

  return (
    <div className={`relative flex items-start ${disabled ? 'pointer-events-none opacity-50' : ''}`}>
      <div className="flex h-5 items-center">
        <input
          id={id}
          name={name}
          value={value ? 'true' : undefined}
          checked={value}
          required={required}
          disabled={disabled}
          onChange={onChange ? () => onChange(!value) : undefined}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          onClick={(e) => {
            if (stopOnClickPropagation) e.stopPropagation();
          }}
        />
      </div>
      <div className="ml-3 text-sm">
        {label && (
          <label htmlFor={id} className="font-medium text-gray-700">
            {label}
          </label>
        )}
        {(helpText || error) && (
          <div className="mt-2">
            {helpText && <p className="text-gray-500">{helpText}</p>}
            {error && <p className="text-red-600">{error}</p>}
          </div>
        )}
      </div>
    </div>
  );
}

export default Checkbox;
